import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuiz} from '@tisa-group/models';
import {Observable} from 'rxjs';

import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class QuizService implements CrudService<UmpireQuiz> {
  constructor(readonly http: TisaUmpireHttpService) {}

  delete(id: string): Observable<void> {
    return this.http.delete(`/quizzes/${id}`);
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireQuiz[]>> {
    return this.http
      .get(`/quizzes`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuiz>> {
    return this.http
      .get(`/quizzes/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireQuiz>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuiz>> {
    return this.http
      .patch(`/quizzes/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireQuiz>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuiz>> {
    return this.http
      .post(`/quizzes`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
